import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Link, useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';
import { formatPrice, getProductSalePrice } from "../../../utils/utils";
import useLang from "../../../hooks/useLang";
import { addItemToCart } from "../../../apis/requests";
import { setCartCount } from "../../redux/reducer";
import store from "../../redux/store";
import { useTranslation } from "react-i18next";
import { isMobile, isTablet } from 'react-device-detect';
const Product = (props) => {
    const lang = useLang();
    const item = props.item;
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [itemPrice, setItemPrice] = useState({});
    const [addToCartLoading, setAddToCartLoading] = useState(false);
    useEffect(() => {
        setItemPrice(getProductSalePrice({
            selling_price: item.selling_price,
            discounted_price: item.discounted_price,
            discount_end_date: item.discount_end_date,
            discount_start_date: item.discount_start_date,
        }));
    }, []);
    const handleAddItemToCart = async () => {
        try {
            if (item.type === "simple" && item.product_fields === '[]') {
                setAddToCartLoading(true);
                let cartId = localStorage.getItem('cart') === null ? crypto.randomUUID() : localStorage.getItem('cart');
                let data = {
                    cart_id: cartId,
                    product: {
                        id: item.id,
                        fields: {

                        }
                    },
                    quantity: 1,
                    type: item.type,
                }
                const res = await addItemToCart(data);
                localStorage.setItem('cart', cartId);
                store.dispatch(setCartCount(res.data.cart_count))
                setAddToCartLoading(false);
                props.showToast();
            } else {
                navigate('/shop/products/' + item.sku, { state: item });
            }
        } catch (error) {
            console.log(error);

        }


    }
    return (
        <div>
            <div className="overflow-hidden m-2" >
                <div
                    className="prod-add-to-fav"
                    style={{
                        position: "relative",
                        top: 50,
                    }}
                >
                    <Button
                        style={{
                            height: 40,
                            width: 40
                        }}
                        rounded
                        severity="secondary"
                        icon={<span className="material-symbols-outlined">favorite</span>}
                    />
                </div>
                <div>
                    <Link
                        to={'/shop/products/' + item.sku}
                        state={item}
                    >
                        <img className="w-full rounded bg-gray-100" src={item.image} alt={item.name} loading="lazy" />
                    </Link>
                    <div>
                        <div className="mt-3 mx-2">
                            <div className="flex justify-between">
                                <div>
                                    <div>
                                        <Link
                                            to={'/shop/products/' + item.sku}
                                            state={item}
                                        >
                                            <span className="text-black lg:text-sm md:text-sm text-sm font-semibold">{lang === "en" ? item.name : item.name_ar}</span>
                                        </Link>
                                    </div>
                                    <div>
                                        <span className="text-sm font-bold text-gray-600">{itemPrice.price}</span>
                                        {
                                            (itemPrice.discount) &&
                                            <span className="text-sm mx-1 hide-xs"
                                                style={{
                                                    textDecorationLine: "line-through"
                                                }}
                                            >{formatPrice(item.selling_price, false)}</span>
                                        }
                                    </div>
                                </div>
                                {
                                    (!isMobile) &&
                                    <div
                                        style={{
                                            marginLeft: 10
                                        }}>
                                        <Button
                                            loading={addToCartLoading}
                                            style={{
                                                height: 40,
                                                width: 40
                                            }}
                                            rounded
                                            outlined
                                            severity="secondary"
                                            icon={<span className="material-symbols-outlined">shopping_cart</span>}
                                            onClick={() => {
                                                handleAddItemToCart();
                                            }}
                                        />
                                    </div>
                                }

                            </div>
                            {
                                (props.showSortType && props.sortType === "top-rated") &&
                                <div >
                                    {Array.from({ length: item.rating }).map((_, i) => (
                                        <span className="text-sm mx-1" key={i} >
                                            &#x2B50;
                                        </span>
                                    ))}
                                </div>
                            }
                            {
                                (props.showSortType && props.sortType === "top-selling") &&
                                <div>
                                    {item.sale_count > 0 &&
                                        <div className="flex items-center gap-1" >
                                            <span className="material-symbols-outlined">
                                                shopping_bag
                                            </span>
                                            <span className="mt-1 text-sm font-semibold">{item.sale_count > 100 ? '100+' : item.sale_count} {t('sales')}</span>
                                        </div>
                                    }

                                </div>

                            }
                            {
                                (isMobile) &&
                                <Button
                                    rounded
                                    onClick={() => {
                                        handleAddItemToCart();
                                    }}
                                    loading={addToCartLoading}
                                    outlined 
                                    className="!my-2 !border-1 !p-2 !text-[#000] !border-[#004040] !px-4 !font-semibold !bg-[#003030] !text-white">
                                    {t('add_to_cart')}
                                </Button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
Product.propTypes = {
    item: PropTypes.object.isRequired,
    showToast: PropTypes.func.isRequired
}
export default Product;
